import { render } from "./SitePolicy.vue?vue&type=template&id=6785a3e1&scoped=true"
const script = {}

import "./SitePolicy.vue?vue&type=style&index=0&id=6785a3e1&scoped=true&lang=css"

import exportComponent from "C:\\Users\\MORIMI\\Documents\\git_repositories\\heightlimit_mapbox\\heightlimit_mapbox\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6785a3e1"]])

export default __exports__